import { render, staticRenderFns } from "./configmodal.vue?vue&type=template&id=60b416cb&"
import script from "./configmodal.vue?vue&type=script&lang=js&"
export * from "./configmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports